module.exports = __webpack_public_path__ + "img/chemmaster-user-avatar.f5be39be.png";